module.exports = __webpack_public_path__ + "img/GuckMalMeinProfil.258ddb9b.jpg";